module.exports = __webpack_public_path__ + "img/logo-ar.6f4a2620.svg";